import React, { useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Chip, FormControl, FormHelperText, Grid, InputLabel, LinearProgress, MenuItem, OutlinedInput, Select, SelectProps, Stack } from '@mui/material';
import { taxesandfeesModel, UsersModel_VS } from '../../models/TaxesAndFeesModel'
import { FieldAttributes, Form, Formik, useField } from 'formik';
import { FMSelectLOBField, FMSelectRateTypeField, FMSelectStateField, FMSelectTaxAndFees, FMSelectTaxTypeField } from '../Elements/select';
import { FMTextField } from '../Elements/input';
import useAuth from "../../context/AuthProvider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import CancelIcon from "@mui/icons-material/Cancel";
import { apiClient } from '../../helper/api';

interface Iprops {
  taxesandfessCL: taxesandfeesModel;
  handleClose: () => void;
  Open: boolean;
  initValues: taxesandfeesModel;
  fetchLOBData: (stateId: string) => void;
  LineOfBusiness: { id: number; businessCode: string; }[];
  setSelectedMultiLOB: React.Dispatch<React.SetStateAction<string | string[]>>;
  SelectedMultiLOB: string[] | string;
}

export const AddEditTaxesAndFees: React.FC<Iprops> = ({ handleClose, Open, taxesandfessCL, initValues, LineOfBusiness, fetchLOBData, setSelectedMultiLOB, SelectedMultiLOB }) => {
  const initialValues: taxesandfeesModel = initValues ? taxesandfessCL : initValues;
  const { user } = useAuth();
  const token = user?.token;
  const [TaxandFees, setTaxandFees] = useState<(string | { policyFilingTypeName?: string; taxName?: string; name?: string })[]>([]);
  const initialStatedata = { stateId: 0, stateName: "" };
  const [States, setStates] = useState([initialStatedata]);
  const [loading, setloading] = useState(false);
  const [taxFeesLoading, setTaxFeesLoading] = useState(true);
  
  function fetchStateData() {
    apiClient("/States/getStates", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
    .then((responseJson) => {
      if (responseJson?.data != null) {
        setStates(responseJson.data);
      }
    })
  };

  const fetchData = () => {
    setTaxFeesLoading(true);
    
    apiClient(`/PolicyFilingType/GetAllTaxandFeeName`, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
    .then((responseJson) => {
      if (responseJson?.data != null && responseJson.data.length > 0) {
        setTaxandFees(responseJson.data);
        setTaxFeesLoading(false);
      } else {
        return apiClient(`/TaxesAndFees/GetAllTaxandFeeName`, {
          method: "GET",
          headers: new Headers({
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }),
        });
      }
    })
    .then((responseJson) => {
      if (responseJson && responseJson.data != null) {
        setTaxandFees(responseJson.data);
      }
    })
    .catch((error) => {
      console.error('Error fetching tax and fees data:', error);
    })
    .finally(() => {
      setTaxFeesLoading(false);
    })
  };

  useEffect(() => {
    fetchData();
    fetchStateData();
  }, []);

  const FMSelectTaxAndFeesustom: React.FC<FieldAttributes<SelectProps>> = ({
    variant,
    ...props
  }) => {
    const [field, meta] = useField<{}>(props);
    const errorText = meta.error && meta.touched ? meta.error : "";

    return (
      <FormControl error={!!errorText} fullWidth>
        <InputLabel id="State-Select-Label">TaxandFees</InputLabel>
        <Select {...field} labelId="State-Select-Label" label="TaxandFees"
          className="border-round main-form-2"
          IconComponent={ExpandMoreIcon}
          displayEmpty
          disabled={taxFeesLoading}
        >
          <MenuItem value="">
            <em>{taxFeesLoading ? 'Loading...' : 'Select Tax'}</em>
          </MenuItem>
           {TaxandFees && TaxandFees.length > 0 ? TaxandFees.map((taxandfees, key) => {
             const taxName = typeof taxandfees === 'string' 
               ? taxandfees 
               : (taxandfees as any)?.policyFilingTypeName || (taxandfees as any)?.taxName || (taxandfees as any)?.name || '';
             const taxValue = typeof taxandfees === 'string' 
               ? taxandfees 
               : (taxandfees as any)?.policyFilingTypeName || (taxandfees as any)?.taxName || (taxandfees as any)?.name || '';
             
             return (
               <MenuItem key={key} value={taxValue}>
                 {taxName}
               </MenuItem>
             );
           }) : !taxFeesLoading && (
             <MenuItem disabled>
               No tax options available
             </MenuItem>
           )}
        </Select>
        <FormHelperText>{errorText}</FormHelperText>
      </FormControl>
    );
  };

  const FMSelectLineOfBusinessCustom: React.FC<FieldAttributes<SelectProps>> = ({
    variant,
    ...props
  }) => {
    const [field, meta] = useField<{}>(props);
    const errorText = meta.error && meta.touched ? meta.error : "";

    return (
      <React.Fragment>
        <FormControl error={!!errorText} fullWidth  >
          <InputLabel id="State-Select-Label">Select Line Of Business</InputLabel>
          <Select {...field}
            labelId="State-Select-Label"
            label="Select Line Of Business"
            className="border-round main-form-2"
            IconComponent={ExpandMoreIcon}
            value={field.value || "" || 0}
          >
            <MenuItem value={"ALL"}>ALL</MenuItem>
            {LineOfBusiness.map((LineOfBusiness, key) => (
              <MenuItem key={key} value={LineOfBusiness.id}>
                {LineOfBusiness.businessCode}{" "}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{errorText}</FormHelperText>
        </FormControl>
      </React.Fragment>
    );
  };

  return (
    <Dialog open={Open} onClose={handleClose}>
      <DialogTitle className='card-title'   >Taxes and Fees</DialogTitle>
      {loading && <LinearProgress sx={{ backgroundColor: "#132D3D" }} />}
      <Formik initialValues={initialValues}
        validateOnChange={true}
        validationSchema={UsersModel_VS}
        onSubmit={(data, { setSubmitting, setErrors }) => {
          setloading(true);

          data.lob = data.lobId === 0 ? 'ALL' : '';
          data.commaSeparatedLOBIds = SelectedMultiLOB.toString();
          if(data.id == 0){
            data.createdBy = `${user?.userFirstName} ${user?.userLastName}`
          }else{
            data.lastEditBy = `${user?.userFirstName} ${user?.userLastName}`
          }
          apiClient('/TaxesAndFees/UpdateCopy',
            {
              method: 'POST',
              headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
              }),
              body: JSON.stringify(data)
            })
            .then((res) => {
              if (!res) return
              setloading(false);
              if (res.resp === 0) {
                Swal.fire({
                  title: res.message,
                  text: "",
                  icon: "success",
                  confirmButtonText: "OK",
                });
              }
              handleClose()
              setSubmitting(true)
            }).catch((error) => {
              setloading(false);
              console.log(error)
            });
        }} >
        {({ values, isSubmitting, errors, setFieldValue }) => (
          <Form>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControl error={!!errors.stateId} sx={{ width: '100%' }}>
                    <Select
                      value={initialValues.stateId}
                      id="test-select-label"
                      label={null}
                      onChange={(e) => {
                        setFieldValue("stateId", e.target.value);
                        initialValues.stateId = Number(e.target.value);
                        initialValues.lobId = 0;
                        fetchLOBData(String(e.target.value));
                      }}
                      name="stateId"
                      className="border-round custom-menu-item"
                      IconComponent={ExpandMoreIcon}
                      displayEmpty
                    >
                      <MenuItem key={0} value={0}>
                        Select State{" "}
                      </MenuItem>
                      {/* <MenuItem value={"0"}>State</MenuItem> */}
                      {States.map((state, key) => (
                        <MenuItem key={key} value={state.stateId}>
                          {state.stateName}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{errors.stateId}</FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} >
                    <FMSelectTaxAndFeesustom autoWidth={true} name="taxName"></FMSelectTaxAndFeesustom>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} >
                    <FMSelectRateTypeField autoWidth={true} name="ratetype"  ></FMSelectRateTypeField>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} className='main-form' >
                    <FMTextField name="rate" autoFocus margin="dense" label="Rate" type="text" fullWidth variant="outlined" sx={{ m: 2 }} />
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} className='main-form' >
                    <FMTextField name="payableto" autoFocus margin="dense" label="Payable To" type="Text" fullWidth variant="outlined" sx={{ m: 2 }} />
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} className='main-form' >
                    <FMTextField name="effectiveDate"  autoFocus margin="dense" label="Effective Date" type="date" InputLabelProps={{ shrink: true }} fullWidth variant="outlined" sx={{ m: 2 }} />
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <FormControl error={false} fullWidth       >
                    <InputLabel id="lob_type">LOB</InputLabel>
                    <Select 
                      className=" main-form-2"
                      disabled={!(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer"))}
                      label="LOB"
                      name="Lob"
                      multiple
                      IconComponent={ExpandMoreIcon}
                      labelId="lob_type"
                      value={SelectedMultiLOB}
                      onChange={(e) => {
                        setSelectedMultiLOB(e.target.value);
                      }}
                      renderValue={(selected) => (
                        <Stack gap={1} direction="row" flexWrap="wrap">
                          {selected.toString().split(',').map((value) => (
                            <Chip
                              key={value}
                              label={LineOfBusiness.find(x => x.id.toString() === value)?.businessCode == undefined ?  'ALL' : LineOfBusiness.find(x => x.id.toString() === value)?.businessCode  }
                              onDelete={() => setSelectedMultiLOB(SelectedMultiLOB?.toString().split(',').filter((item) => item !== value))}
                              disabled={!(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer"))}
                              deleteIcon={<CancelIcon
                                onMouseDown={(event) => event.stopPropagation()}
                              />}
                            />
                          ))}
                        </Stack>
                      )}
                    >
                      <MenuItem value={"ALL"}>ALL</MenuItem>
                      {LineOfBusiness.map((Role, key) =>
                        <MenuItem key={key} value={Role.id.toString()}> {Role.businessCode} </MenuItem>
                      )}
                    </Select>
                    <FormHelperText>{false}</FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <FormControl sx={{ width: '100%' }} className='main-form' >
                    <FormHelperText></FormHelperText>
                    <FMTextField name="taxPayee" autoFocus margin="dense" label="Tax Payee" type="text" fullWidth variant="outlined" sx={{ m: 2 }} />
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl sx={{ width: '100%' }} >
                    <FormHelperText></FormHelperText>
                    <FMTextField name="notes" autoFocus margin="dense" multiline rows={3} label="Notes" type="Text" fullWidth variant="outlined" sx={{ m: 2 }} />
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions>
              <button className=" btn-2 btn d-flex btn-primary search-btn" type='button' onClick={handleClose}  >Cancel</button>
              <button className=" btn  btn-primary active-btn-blue  search-btn " type='submit' disabled={isSubmitting} >Submit</button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}
